import React, { useState } from 'react'
import ReactPlayer from 'react-player/vimeo'
import {FaTimes} from 'react-icons/fa'
import {FaPlay} from 'react-icons/fa'

function Tab2({values, handleChange, setFieldValue, errors, touched}) {
  const [transcriptFile, setTranscriptFile] = useState(null)
  const [transcriptData, setTranscriptData] = useState(null)
  
  const removeVideo = (i) => {
    const updatedVideos = values.videos.filter((_, index) => index !== i)
    setFieldValue('videos', updatedVideos)
  }

  const handleTranscriptFileChange = (e) => {
    const file = e.target.files[0]
    if (file && file.type === 'application/json') {
      setTranscriptFile(file)
      const reader = new FileReader()
      reader.onload = (event) => {
        try {
          const jsonData = JSON.parse(event.target.result)
          
          // Parse cue_start and cue_end from string to number
          const processedData = processTranscriptData(jsonData)
          setTranscriptData(processedData)
        } catch (error) {
          console.error('Error parsing JSON file:', error)
          setTranscriptData(null)
          alert('Invalid JSON file. Please select a valid JSON file.')
        }
      }
      reader.readAsText(file)
    }
  }

  const processTranscriptData = (data) => {
    // If data is an array of cues
    if (Array.isArray(data)) {
      return data.map(cue => ({
        ...cue,
        cue_start: typeof cue.cue_start === 'string' ? parseFloat(cue.cue_start) : cue.cue_start,
        cue_end: typeof cue.cue_end === 'string' ? parseFloat(cue.cue_end) : cue.cue_end
      }))
    }
    
    // If data is an object with cues array
    if (data.cues && Array.isArray(data.cues)) {
      return {
        ...data,
        cues: data.cues.map(cue => ({
          ...cue,
          cue_start: typeof cue.cue_start === 'string' ? parseFloat(cue.cue_start) : cue.cue_start,
          cue_end: typeof cue.cue_end === 'string' ? parseFloat(cue.cue_end) : cue.cue_end
        }))
      }
    }
    
    // If data is a single cue object
    if (data.cue_start !== undefined || data.cue_end !== undefined) {
      return {
        ...data,
        cue_start: typeof data.cue_start === 'string' ? parseFloat(data.cue_start) : data.cue_start,
        cue_end: typeof data.cue_end === 'string' ? parseFloat(data.cue_end) : data.cue_end
      }
    }
    
    // Return data as is if no cue_start/cue_end found
    return data
  }

  const resetTranscript = () => {
    setTranscriptFile(null)
    setTranscriptData(null)
  }

  return (
    <div>
      <div className='col-lg-12'>
        <div className='d-flex align=items-center flex-wrap gap-3'>
          <div>
            <label className='col-form-label required fw-bold fs-6'>Title</label>
            <input
              type='text'
              name='title'
              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
              placeholder='Video Title'
              value={values.title}
              onChange={handleChange}
            />
          </div>

          <div>
            <label className='col-form-label required fw-bold fs-6'>Add Vimeo Link</label>
            <input
              type='text'
              className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
              placeholder='Enter Vimeo Link'
              name='link'
              value={values.link}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className='pt-8 pb-4'>
          <label className='col-form-label required fw-bold fs-6'>Description</label>
          <textarea
            className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 w-50'
            style={{height: '100px'}}
            name='description'
            placeholder='Short description'
            value={values.description}
            onChange={handleChange}
          />
        </div>

        <div className='pb-4'>
          <label className='col-form-label fw-bold fs-6'>Transcript File</label>
          <div className='d-flex align-items-center gap-3 w-50'>
            <input
              type='file'
              accept='.json'
              onChange={handleTranscriptFileChange}
              className='form-control form-control-solid'
              style={{ width: 'auto' }}
            />
            <button
              type='button'
              className='btn btn-primary'
              onClick={() => {
                const fileInput = document.querySelector('input[type="file"]')
                if (fileInput) fileInput.click()
              }}
            >
              Add Transcript
            </button>
          </div>
        </div>
        
      </div>
      <button
        type='button'
        className='btn btn-primary me-2'
        onClick={() => {
          const videoObject = {
            title: values.title,
            link: values.link,
            description: values.description,
          }
          
          // Include transcript data if available
          if (transcriptData) {
            videoObject.transcript = transcriptData
          }
          
          setFieldValue('videos', [
            ...values.videos,
            videoObject,
          ])
          
          // Reset transcript after adding
          resetTranscript()
          
          // Clear the file input
          const fileInput = document.querySelector('input[type="file"]')
          if (fileInput) fileInput.value = ''
        }}
      >
        <span className='indicator-label'>Add</span>
      </button>
      {touched.videos && errors.videos && (
            <div className='fv-plugins-message-container my-5'>
              <span role='alert' className='text-danger'>{errors.videos}</span>
            </div>
          )}
      {values.videos && values.videos.length > 0 && <hr className='hr my-8' />}
      {values.videos && values.videos.length > 0 && <div className='fw-bold m-0'>Videos</div>}

      <div className='mt-3 d-flex justify-content-start align-items-start gap-10 flex-wrap'
      
      >
        {values?.videos &&
          values?.videos.map((val, index) => (
            <div
              className='shadow-lg overflow-hidden position-relative bg-white text-black'
              key={index}
              style={{
                width: '220px',
                borderRadius: '9px',
              }}
            >
              <div className='player-wrapper position-relative'>
                <ReactPlayer className='react-player' width='100%' height='160px' url={val?.link} />
                <div className='icon-overlay position-absolute' style={{left:'50%', top:'50%', transform: 'translate(-50%, -50%)'}}>
                  <FaPlay  size={50} color='black' />
                </div>
              </div>
              <div className='position-absolute top-0 end-0 p-1'>
              <div className="rounded-3 p-1" style={{position:'absolute', top:'4px', right:'4px', background:'white'}}>
                <FaTimes
                  style={{
                    color: 'black',
                    cursor: 'pointer',
                    fontSize: '18px',
                  }}
                  onClick={() => removeVideo(index)}
                />
                </div>
              </div>
              <hr className='hr' />
              <div className='px-2 ' style={{height:'90px'}}>
                <div className='fw-bold fs-7'> {val?.title?.length > 28
                    ? val?.title.slice(0, 28) + ' ....'
                    : val?.title}</div>
                <div className='mb-3 text-start fs-8 fw-light mt-2'>
                  {val?.description?.length > 90
                    ? val?.description.slice(0, 90) + ' ....'
                    : val?.description}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default Tab2
